var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "form-wrapper" },
            [
              _c(
                "keep-alive",
                [
                  _c(_vm.componentName, {
                    ref: "dynamic",
                    tag: "component",
                    on: {
                      invitation: _vm.invitationFn,
                      invitationFn: _vm.invitationFn,
                      onDelete: _vm.onDelete,
                      onQuit: _vm.onQuit,
                      onWorker: _vm.onWorker,
                      openDrawer: _vm.openDrawer,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("UserDetails", {
            ref: "userDetails",
            attrs: { actionType: _vm.actionType, tabtypes: _vm.tabtypes },
            on: { getList: _vm.getList },
          }),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                "before-close": _vm.handleClose,
                title: _vm.linkTitle,
                visible: _vm.linkShow,
                top: "20%",
                width: "560px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.linkShow = $event
                },
              },
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.linkTable))]),
              _vm._v(" "),
              _c("div", { staticClass: "tips" }, [
                _vm._v("提示：" + _vm._s(_vm.linkContent)),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.linkShow = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.copy } },
                    [_vm._v("复制邀请链接")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("oa-dialog", {
        ref: "oaDialog",
        attrs: {
          fromData: _vm.fromData,
          formConfig: _vm.formConfig,
          formRules: _vm.formRules,
          formDataInit: _vm.formDataInit,
        },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }